export default __webpack_public_path__ + "static/media/memory-game.ef34f51b.png";